<template lang="pug">
  .face-biometric-screen-wrapper
    h2 gerenciamento de biometria facial
    .filters
      RadioSlider(
        :items="categories.items",
        :current="categories.items.findIndex(i => i.id === categories.selected.id)",
        @selected="openItemsSelector"
      )

      .items-selector
        PMultiSelect(
          ref="itemSelector"
          labelItem="name"
          :title="categorieSelected.name"
          :forcedPlaceholder="forcedPlaceholder"
          :useState="categorieSelected.useState"
          :useCommon="categorieSelected.common"
          :disabled="!categories.selected"
        )

      .consult
        PButton(
          color="success"
          size="md"
          @click="onClickBuscar"
          block
          :disabled="!validSearch"
          :loading="loading"
        )
          | buscar

    .info
      .total
        span total de {{ $wp('employee') }}: {{ filteredList.length }}

    .result
      .biometric-card-container(v-if="filteredList.length > 0")
        template(v-for="biometric in filteredList")
          BiometricEmployee(:data="biometric", :key="biometric.employee.id")
      .biometric-card-container(v-else)
        center
          h1 Nenhuma foto para mostrar
</template>

<script>
import { CompStoreModule } from 'src/common/mixins/abstractComponents'
import { mapState } from 'vuex'

import { generateObjectId } from 'src/utils'
import BiometricEmployee from './BiometricEmployeeCard'

export default {
  extends: CompStoreModule,
  storeModule: 'faceBiometric',
  name: 'faceBiometricScreen',
  created () {
    this.categories.selected = this.categories.items[0]
  },
  data () {
    return {
      categories: {
        selected: null,
        items: [
          { name: this.$wp('company'), id: 'company', alias: 'work-place', common: 'companies/onlyActive', useState: 'faceBiometric/companies' },
          { name: this.$wp('employee'), id: 'employee', alias: 'employee', common: 'employees/onlyNotFired', useState: 'faceBiometric/employees' }
        ]
      }
    }
  },
  computed: {
    ...mapState('faceBiometric', ['employees', 'companies', 'loading', 'currentReqId', 'list']),
    categorieSelected () {
      if (this.categories.selected) return this.categories.selected

      return {
        name: 'Selecionar',
        id: 'company',
        alias: 'work-place',
        common: 'companies/onlyActive',
        useState: 'verifyTimesheet/companies'
      }
    },
    forcedPlaceholder () {
      const companies = this.companies.selected
      const employees = this.employees.selected

      if (companies.length || employees.length) {
        return null
      }

      if (this.categories.selected.id === 'company') {
        return 'selecionar ' + this.$wp('companyShortName')
      } else {
        return 'selecionar ' + this.$wp('employee')
      }
    },
    validSearch () {
      if (!this.employees.selected.length && !this.companies.selected.length) {
        return false
      }
      return true
    },
    filteredList () {
      return this.list.filter(obj => obj.biometrics.length > 0)
    }
  },
  methods: {
    async onClickBuscar () {
      let result = {ok: false}
      if (this.companies.selected.length <= 0 && this.employees.selected.length <= 0) {
        await this.$swal({ type: 'error', text: `Selecione pelo menos um ${this.$ws('employee')} ou local de trabalho para buscar` })
        return
      }
      this.$store.commit('faceBiometric/resetList')

      const thisReqId = generateObjectId()
      if (this.employees.selected.length > 0) {
        result = await this.$store.dispatch('faceBiometric/loadBiometrics', {
          reqId: thisReqId,
          params: {
            filter_type: 'employee',
            filter_ids: this.employees.selected.map(e => e.id)
          }
        })
      } else {
        result = await this.$store.dispatch('faceBiometric/loadBiometrics', {
          reqId: thisReqId,
          params: {
            filter_type: 'company',
            filter_ids: this.companies.selected.map(c => c.id)
          }
        })
      }
      if (this.$store.state.faceBiometric.currentReqId === thisReqId) {
        if (result.ok) {
          this.$store.commit('faceBiometric/list', result.body.success)
        }
      } else {
        console.log(`oops. request: ${thisReqId} but the newer is ${this.$store.state.faceBiometric.currentReqId}`)
      }
    },
    openItemsSelector (item) {
      this.categories.selected = item
      this.$refs.itemSelector.open()
    }
  },
  components: { BiometricEmployee }
}
</script>

<style lang="scss" scoped>
.face-biometric-screen-wrapper {
  h2 {
    text-align: center;
  }
  .filters {
    display: grid;
    grid-template-columns: .7fr 1fr .2fr;
    grid-column-gap: 10px;
    align-items: center;
    margin-top: 20px;
  }
  .result {
    margin-top: 20px;
  }
}
</style>
